import { makeStyles, Theme } from '@material-ui/core'

import { TooltipProps } from './TooltipProps'

export const useTooltipStyles = makeStyles<Theme, TooltipProps>(({ typography }) => ({
  tooltip: {
    fontSize: typography.pxToRem(16),
  },
}))
